// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Rwe1","bigColWidth":"Table_bigColWidth__3rIeQ","biggerColWidth":"Table_biggerColWidth__U_NZK","row":"Table_row__co_1f","col":"Table_col__1H8Bg"};